
// frontend/app/i18n/useTranslation.js
import { useMemo } from 'react'
import translations from './dictionary'
import { useAuth } from "../AuthContext"

/**
 * Map from your locale‐codes → the translation‐json key
 * for that language's own name.
 */
const localeToKey = {
  en: 'English',
  es: 'Spanish',
  hi: 'Hindi',
  fr: 'French',
  zh: 'Chinese (Simplified)',
  ja: 'Japanese',
  ko: 'Korean',
  de: 'German',
  it: 'Italian',
  ru: 'Russian',
  ar: 'Arabic',
  gu: 'Gujarati',
  te: 'Telugu',
  mr: 'Marathi',
  pt: 'Portuguese',
}

/**
 * Substitute `{token}` placeholders in `template` with values from `params`.
 *
 * - `params` null/undefined/not a plain object → `template` is returned unchanged (braces
 *   survive). This keeps existing call sites that do their own
 *   `t("Hi {name}").replace("{name}", value)` working untouched.
 * - Otherwise every `{token}` whose `token` is an own key of `params` is replaced with
 *   `String(params[token])`; a `{token}` with no matching key is left as-is; extra keys in
 *   `params` are ignored.
 * - Replacement is literal and single-pass: a substituted value that itself contains `{x}`
 *   is not re-scanned.
 * - `template` not a string → returned unchanged.
 */
export function interpolate(template, params) {
  if (typeof template !== "string") return template
  if (params === null || params === undefined || typeof params !== "object" || Array.isArray(params)) {
    return template
  }

  return template.replace(/\{(\w+)\}/g, (match, token) => {
    if (!Object.prototype.hasOwnProperty.call(params, token)) return match
    return String(params[token])
  })
}

/**
 * Pure lookup: `entry[lang] || entry.en || key`, then interpolate.
 * Unknown key → the key itself (interpolated).
 */
export function translate(dict, lang, key, params) {
  const entry = dict[key]
  if (!entry) return interpolate(key, params)
  return interpolate(entry[lang] || entry.en || key, params)
}

export function useTranslation() {
    const { selectedSecondaryLang } = useAuth()
    const lang = selectedSecondaryLang === "auto" ? "en" : selectedSecondaryLang

  // 1) the t() lookup function
  const t = (key, params) => translate(translations, lang, key, params)

  // 2) build your picker options:
  //    include "auto" + each supported locale
  const languageOptions = useMemo(() => {
    const opts = [
      { id: 'auto', name: t('Auto Detect') },
      // now one entry per real code:
      ...Object.entries(localeToKey).map(([code, displayKey]) => ({
        id: code,
        name: t(displayKey),
      })),
    ]
    return opts
  }, [lang])

  return { t, languageOptions }
}



// import { useMemo } from "react"
// import translations from "./translation.json"

// /**
//  * @param {string} lang  two‑letter code, e.g. "en", "hi", etc.
//  */
// export function useTranslation(lang = "en") {
//   // fallback to English if key or locale missing
//   const t = (key) => {
//     const entry = translations[key]
//     if (!entry) return key
//     return entry[lang] || entry["en"] || key
//   }

//   // list of supported locales (from your JSON)
//   const availableLanguages = useMemo(
//     () => Object.values(translations)?.[0]
//       ? Object.keys(translations[Object.keys(translations)[0]])
//       : ["en"],
//     []
//   )

//   return { t, availableLanguages }
// }